import { render } from "./GeneralServices.vue?vue&type=template&id=65c8022f&scoped=true"
import script from "./GeneralServices.vue?vue&type=script&lang=js"
export * from "./GeneralServices.vue?vue&type=script&lang=js"

import "./GeneralServices.vue?vue&type=style&index=0&id=65c8022f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c8022f"]])

export default __exports__